<template>
  <div class=" mx-auto pt-10 w-full max-w-xl max-h-80">
    <iframe
      width="560"
      height="315"
      src="https://www.youtube.com/embed/rD5qZkULSaU?autoplay=1&mute=1&controls=0&loop=1&modestbranding"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;"
      
    ></iframe>
  </div>
</template>
